import { createFileRoute } from '@tanstack/react-router';

import { getValorantAgentsOptions } from '@/features/games/valorant/hooks/useGetValorantAgents';
import { getValorantPlayerOptions } from '@/features/games/valorant/hooks/useGetValorantPlayer';
import { FavouriteAgentStep } from '@/features/onboarding/components/steps/riot/favouriteAgentStep';
import { getMyUserOptions } from '@/features/users/hooks/useGetMyUser/getMyUser.options';

export const Route = createFileRoute(
  '/_protected/onboarding/_steps/favourite-agent',
)({
  component: RouteComponent,
  loader: async ({ context }) => {
    const [, userResponse] = await Promise.all([
      context.queryClient.ensureQueryData(getValorantAgentsOptions()),
      context.queryClient.ensureQueryData(getMyUserOptions()),
    ]);

    if (userResponse.user.riotPuuid) {
      await context.queryClient.ensureQueryData(
        getValorantPlayerOptions({ puuid: userResponse.user.riotPuuid }),
      );
    }
  },
});

function RouteComponent() {
  return <FavouriteAgentStep />;
}
